import { getNetworkInfo } from '@/utils/webOS';
import { logger } from '@/utils/screenEventsLogger';
import { isTizenConnectedToInternet } from '@/utils/tizen';

const NETWORK_CHECK_TIMEOUT = 3000;

function withTimeout(promise, timeout) {
  return Promise.race([
    promise,
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Network check timed out')), timeout),
    ),
  ]);
}

async function getWebOsConnectionStatus() {
  const networkInfo = await withTimeout(getNetworkInfo(), NETWORK_CHECK_TIMEOUT);
  return networkInfo.isInternetConnectionAvailable === true;
}

export async function getConnectionStatus() {
  try {
    if (window.isWebOS) {
      return await getWebOsConnectionStatus();
    } else if (window.isTizen) {
      return isTizenConnectedToInternet();
    }
  } catch (error) {
    // Native API not available or the call failed, fall back to the browser status.
    logger.addLog(`Failed to get native connection status: ${error?.message || 'NA'}.`);
  }
  return navigator.onLine;
}
